/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    BulkSetOperationalStatusRequest,
    ChangeConfigurationTask,
    ChangeExtendedConfigurationTask,
    ConnectorDto,
    CreatePassthroughChildDeviceRequest,
    DeviceAccessTagsSetRequest,
    DeviceAuthorizationDto,
    DeviceConfigurationExtendedDto,
    DeviceConfigurationItemDto,
    DeviceConnectionStatusResponse,
    DeviceConnectorUptimeResponse,
    DeviceDto,
    DeviceListReponse,
    DeviceMaintenanceStatusLogDto,
    DeviceProtocolUpdateDto,
    DeviceUptimeResponse,
    InsertDeviceMaintenanceStatusRequest,
    PayMateConnectorAssignmentDto,
    PayMateConnectorAssignmentsResponseDto,
    PayMateTransactionDto,
    ProvisionDeviceRequest,
    ReprovisionDeviceRequest,
    UpdateDeviceAuthorizationRequest,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    BulkSetOperationalStatusRequestFromJSON,
    BulkSetOperationalStatusRequestToJSON,
    ChangeConfigurationTaskFromJSON,
    ChangeConfigurationTaskToJSON,
    ChangeExtendedConfigurationTaskFromJSON,
    ChangeExtendedConfigurationTaskToJSON,
    ConnectorDtoFromJSON,
    ConnectorDtoToJSON,
    CreatePassthroughChildDeviceRequestFromJSON,
    CreatePassthroughChildDeviceRequestToJSON,
    DeviceAccessTagsSetRequestFromJSON,
    DeviceAccessTagsSetRequestToJSON,
    DeviceAuthorizationDtoFromJSON,
    DeviceAuthorizationDtoToJSON,
    DeviceConfigurationExtendedDtoFromJSON,
    DeviceConfigurationExtendedDtoToJSON,
    DeviceConfigurationItemDtoFromJSON,
    DeviceConfigurationItemDtoToJSON,
    DeviceConnectionStatusResponseFromJSON,
    DeviceConnectionStatusResponseToJSON,
    DeviceConnectorUptimeResponseFromJSON,
    DeviceConnectorUptimeResponseToJSON,
    DeviceDtoFromJSON,
    DeviceDtoToJSON,
    DeviceListReponseFromJSON,
    DeviceListReponseToJSON,
    DeviceMaintenanceStatusLogDtoFromJSON,
    DeviceMaintenanceStatusLogDtoToJSON,
    DeviceProtocolUpdateDtoFromJSON,
    DeviceProtocolUpdateDtoToJSON,
    DeviceUptimeResponseFromJSON,
    DeviceUptimeResponseToJSON,
    InsertDeviceMaintenanceStatusRequestFromJSON,
    InsertDeviceMaintenanceStatusRequestToJSON,
    PayMateConnectorAssignmentDtoFromJSON,
    PayMateConnectorAssignmentDtoToJSON,
    PayMateConnectorAssignmentsResponseDtoFromJSON,
    PayMateConnectorAssignmentsResponseDtoToJSON,
    PayMateTransactionDtoFromJSON,
    PayMateTransactionDtoToJSON,
    ProvisionDeviceRequestFromJSON,
    ProvisionDeviceRequestToJSON,
    ReprovisionDeviceRequestFromJSON,
    ReprovisionDeviceRequestToJSON,
    UpdateDeviceAuthorizationRequestFromJSON,
    UpdateDeviceAuthorizationRequestToJSON,
} from "../models/index";

export interface BulkSetDeviceOperationalStatusRequest {
    body?: BulkSetOperationalStatusRequest;
}

export interface ChargerPayMateConnectorAssignmentsGetRequest {
    deviceIdentity: string;
}

export interface ChargerPayMateConnectorAssignmentsSetRequest {
    deviceIdentity: string;
    body?: Array<PayMateConnectorAssignmentDto>;
}

export interface ChargerPayMateGetRequest {
    deviceIdentity: string;
    deviceArchiveId?: number;
}

export interface ChargerPayMateLinkRequest {
    deviceIdentity: string;
    deviceArchiveId?: number;
    payMateDeviceIdentity?: string;
    payMateDeviceArchiveId?: number;
}

export interface CreatePassthroughChildDeviceOperationRequest {
    deviceIdentity: string;
    body?: CreatePassthroughChildDeviceRequest;
}

export interface DeviceAccessTagsSetOperationRequest {
    deviceIdentity: string;
    body?: DeviceAccessTagsSetRequest;
}

export interface DeviceArchiveRequest {
    deviceIdentity: string;
}

export interface DeviceAuthorizationGetRequest {
    deviceIdentity: string;
}

export interface DeviceAuthorizationUpdateRequest {
    deviceIdentity: string;
    body?: UpdateDeviceAuthorizationRequest;
}

export interface DeviceConfigurationSetRequest {
    deviceIdentity: string;
    body?: Array<DeviceConfigurationItemDto>;
}

export interface DeviceConfigurationUpdateRequest {
    deviceIdentity: string;
    body?: ChangeConfigurationTask;
}

export interface DeviceConnectionStatusesRequest {
    deviceIdentities: Array<string>;
}

export interface DeviceConnectorEditRequest {
    deviceIdentity: string;
    body: ConnectorDto;
}

export interface DeviceConnectorUptimeRequest {
    deviceIdentity: string;
    from?: string;
    to?: string;
}

export interface DeviceDailyUptimesRequest {
    deviceIdentity: string;
    from?: string;
    to?: string;
}

export interface DeviceDecommissionRequest {
    deviceIdentity: string;
}

export interface DeviceDetailRequest {
    deviceIdentity: string;
    deviceArchiveId?: number;
}

export interface DeviceExtendedConfigurationGetRequest {
    deviceIdentity: string;
}

export interface DeviceExtendedConfigurationUpdateRequest {
    deviceIdentity: string;
    body?: ChangeExtendedConfigurationTask;
}

export interface DeviceListRequest {
    registrationStatus?: DeviceListRegistrationStatusEnum;
    deviceType?: DeviceListDeviceTypeEnum;
    deviceOwnerId?: number;
    accessTag?: string;
    nestChildDevices?: boolean;
    limit?: number;
    cursor?: string;
}

export interface DeviceListForGroupAssignmentODataRequest {
    deviceGroupTag: string;
}

export interface DeviceLiveLogEnableRequest {
    deviceIdentity: string;
    expiryMinutes?: number;
}

export interface DeviceLocationSetRequest {
    deviceIdentity: string;
    body?: DeviceDto;
}

export interface DeviceMaintenanceStatusLogsOdataRequest {
    deviceIdentity: string;
}

export interface DeviceManagedByUpdateRequest {
    deviceIdentity: string;
    managedBy: DeviceManagedByUpdateManagedByEnum;
}

export interface DeviceParentGetRequest {
    deviceIdentity: string;
    deviceArchiveId?: number;
}

export interface DeviceParentSetRequest {
    deviceIdentity: string;
    deviceArchiveId?: number;
    parentDeviceIdentity?: string;
    parentDeviceArchiveId?: number;
}

export interface DeviceProvisionRequest {
    body?: ProvisionDeviceRequest;
}

export interface DeviceRemoveRequest {
    deviceIdentity: string;
}

export interface DeviceUndoDecommissionRequest {
    deviceIdentity: string;
}

export interface DeviceUptimeRequest {
    deviceIdentity: string;
    from?: string;
    to?: string;
}

export interface InsertDeviceMaintenanceStatusOperationRequest {
    deviceIdentity: string;
    body?: InsertDeviceMaintenanceStatusRequest;
}

export interface PayMateSessionListODataRequest {
    deviceIdentity: string;
}

export interface PrepareDeviceForReprovisioningRequest {
    deviceIdentity: string;
    timeoutMinutes?: number;
}

export interface ReprovisionDeviceOperationRequest {
    existingDeviceIdentity: string;
    body: ReprovisionDeviceRequest;
}

export interface SetDeviceOperationalStatusRequest {
    deviceIdentity: string;
    operationalAt?: string;
}

export interface SetDeviceProtocolRequest {
    deviceIdentity: string;
    body?: DeviceProtocolUpdateDto;
}

export interface SetReadonlyPassthroughDeviceRequest {
    deviceIdentity: string;
    body?: CreatePassthroughChildDeviceRequest;
}

export interface StartPollingCoreSnapshotRequest {
    deviceIdentity: string;
}

export interface UpdateChargerOcppConnectionRequest {
    deviceIdentity: string;
    ocppConnectionUriTemplate: string;
    newDeviceIdentity?: string;
    reboot?: boolean;
    allowOnlyIfOnIlluminate?: boolean;
    refreshConfig?: boolean;
    validateOnly?: boolean;
}

export interface ValidateNewDeviceRequest {
    newDeviceIdentity?: string;
}

/**
 *
 */
export class DeviceHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Set operational at for a list of devices. Requires device_operational_update permission.
     */
    async bulkSetDeviceOperationalStatusRaw(
        requestParameters: BulkSetDeviceOperationalStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/bulk-operational-status`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: BulkSetOperationalStatusRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set operational at for a list of devices. Requires device_operational_update permission.
     */
    async bulkSetDeviceOperationalStatus(
        requestParameters: BulkSetDeviceOperationalStatusRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.bulkSetDeviceOperationalStatusRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Every connector of the charger with the PayMate (if any) that sells it, plus whether the charger\'s connectors are split across multiple child PayMate terminals (hasChildPayMates=true) or served by a single linked PayMate.
     */
    async chargerPayMateConnectorAssignmentsGetRaw(
        requestParameters: ChargerPayMateConnectorAssignmentsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<PayMateConnectorAssignmentsResponseDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling chargerPayMateConnectorAssignmentsGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/paymate/connector-assignments`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            PayMateConnectorAssignmentsResponseDtoFromJSON(jsonValue),
        );
    }

    /**
     * Every connector of the charger with the PayMate (if any) that sells it, plus whether the charger\'s connectors are split across multiple child PayMate terminals (hasChildPayMates=true) or served by a single linked PayMate.
     */
    async chargerPayMateConnectorAssignmentsGet(
        requestParameters: ChargerPayMateConnectorAssignmentsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<PayMateConnectorAssignmentsResponseDto> {
        const response = await this.chargerPayMateConnectorAssignmentsGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Full-replace of the charger\'s per-connector PayMate assignments (parent/child PayMates). Each assigned PayMate must be a child of the charger\'s linked (parent) PayMate. An empty array clears all assignments; connectors without an entry are not sold by any terminal. Affected terminals are soft-reset to re-pull their configs. Requires system_device_provisioning permission.
     */
    async chargerPayMateConnectorAssignmentsSetRaw(
        requestParameters: ChargerPayMateConnectorAssignmentsSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling chargerPayMateConnectorAssignmentsSet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/paymate/connector-assignments`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters["body"]!.map(
                    PayMateConnectorAssignmentDtoToJSON,
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Full-replace of the charger\'s per-connector PayMate assignments (parent/child PayMates). Each assigned PayMate must be a child of the charger\'s linked (parent) PayMate. An empty array clears all assignments; connectors without an entry are not sold by any terminal. Affected terminals are soft-reset to re-pull their configs. Requires system_device_provisioning permission.
     */
    async chargerPayMateConnectorAssignmentsSet(
        requestParameters: ChargerPayMateConnectorAssignmentsSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.chargerPayMateConnectorAssignmentsSetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get charger\'s linked PayMate, or 404 if none
     */
    async chargerPayMateGetRaw(
        requestParameters: ChargerPayMateGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling chargerPayMateGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceArchiveId"] != null) {
            queryParameters["deviceArchiveId"] =
                requestParameters["deviceArchiveId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/paymate`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get charger\'s linked PayMate, or 404 if none
     */
    async chargerPayMateGet(
        requestParameters: ChargerPayMateGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceDto> {
        const response = await this.chargerPayMateGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Link or unlink a charger to a PayMate
     */
    async chargerPayMateLinkRaw(
        requestParameters: ChargerPayMateLinkRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling chargerPayMateLink().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceArchiveId"] != null) {
            queryParameters["deviceArchiveId"] =
                requestParameters["deviceArchiveId"];
        }

        if (requestParameters["payMateDeviceIdentity"] != null) {
            queryParameters["payMateDeviceIdentity"] =
                requestParameters["payMateDeviceIdentity"];
        }

        if (requestParameters["payMateDeviceArchiveId"] != null) {
            queryParameters["payMateDeviceArchiveId"] =
                requestParameters["payMateDeviceArchiveId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/paymate`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Link or unlink a charger to a PayMate
     */
    async chargerPayMateLink(
        requestParameters: ChargerPayMateLinkRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.chargerPayMateLinkRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Create a virtual child device for a real device (only if one doesn\'t already exist). Updates the real device\'s ChargePointMetadata.ManagedBy, and soft resets the device. Requires Permission.device_passthrough_manage
     */
    async createPassthroughChildDeviceRaw(
        requestParameters: CreatePassthroughChildDeviceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling createPassthroughChildDevice().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/create-passthrough`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: CreatePassthroughChildDeviceRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create a virtual child device for a real device (only if one doesn\'t already exist). Updates the real device\'s ChargePointMetadata.ManagedBy, and soft resets the device. Requires Permission.device_passthrough_manage
     */
    async createPassthroughChildDevice(
        requestParameters: CreatePassthroughChildDeviceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createPassthroughChildDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set Device Access Tags. Requires user to have IlluminateAdmin access tag
     */
    async deviceAccessTagsSetRaw(
        requestParameters: DeviceAccessTagsSetOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceAccessTagsSet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/access-tags`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceAccessTagsSetRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set Device Access Tags. Requires user to have IlluminateAdmin access tag
     */
    async deviceAccessTagsSet(
        requestParameters: DeviceAccessTagsSetOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceAccessTagsSetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Archive a device. If this is a virtual passthrough, soft resets the parent device (if online). Requires system_device_deprovisioning permission.
     */
    async deviceArchiveRaw(
        requestParameters: DeviceArchiveRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceArchive().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Archive a device. If this is a virtual passthrough, soft resets the parent device (if online). Requires system_device_deprovisioning permission.
     */
    async deviceArchive(
        requestParameters: DeviceArchiveRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceArchiveRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get device authorization. Requires device_passthrough_manage permission.
     */
    async deviceAuthorizationGetRaw(
        requestParameters: DeviceAuthorizationGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceAuthorizationDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceAuthorizationGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/authorization`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceAuthorizationDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get device authorization. Requires device_passthrough_manage permission.
     */
    async deviceAuthorizationGet(
        requestParameters: DeviceAuthorizationGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceAuthorizationDto> {
        const response = await this.deviceAuthorizationGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update device authorization mode and key. Requires device_passthrough_manage permission.
     */
    async deviceAuthorizationUpdateRaw(
        requestParameters: DeviceAuthorizationUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceAuthorizationUpdate().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/authorization`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: UpdateDeviceAuthorizationRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update device authorization mode and key. Requires device_passthrough_manage permission.
     */
    async deviceAuthorizationUpdate(
        requestParameters: DeviceAuthorizationUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceAuthorizationUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Obsolete, use DeviceConfigurationUpdate task api. Set Device configuration. Requires user to have IlluminateAdmin access tag
     * @deprecated
     */
    async deviceConfigurationSetRaw(
        requestParameters: DeviceConfigurationSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceConfigurationItemDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceConfigurationSet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/configuration`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters["body"]!.map(
                    DeviceConfigurationItemDtoToJSON,
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceConfigurationItemDtoFromJSON),
        );
    }

    /**
     * Obsolete, use DeviceConfigurationUpdate task api. Set Device configuration. Requires user to have IlluminateAdmin access tag
     * @deprecated
     */
    async deviceConfigurationSet(
        requestParameters: DeviceConfigurationSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceConfigurationItemDto>> {
        const response = await this.deviceConfigurationSetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set (or add if not exist) device configuration item. Will return a taskId if device is online, else will update db. Admin only.
     */
    async deviceConfigurationUpdateRaw(
        requestParameters: DeviceConfigurationUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceConfigurationUpdate().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/configuration`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PATCH",
                headers: headerParameters,
                query: queryParameters,
                body: ChangeConfigurationTaskToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set (or add if not exist) device configuration item. Will return a taskId if device is online, else will update db. Admin only.
     */
    async deviceConfigurationUpdate(
        requestParameters: DeviceConfigurationUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceConfigurationUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the connection status for multiple devices.
     */
    async deviceConnectionStatusesRaw(
        requestParameters: DeviceConnectionStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceConnectionStatusResponse>> {
        if (requestParameters["deviceIdentities"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentities",
                'Required parameter "deviceIdentities" was null or undefined when calling deviceConnectionStatuses().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceIdentities"] != null) {
            queryParameters["deviceIdentities"] = requestParameters[
                "deviceIdentities"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/connection-statuses`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceConnectionStatusResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get the connection status for multiple devices.
     */
    async deviceConnectionStatuses(
        requestParameters: DeviceConnectionStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceConnectionStatusResponse> {
        const response = await this.deviceConnectionStatusesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Edit device connector details.
     */
    async deviceConnectorEditRaw(
        requestParameters: DeviceConnectorEditRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceConnectorEdit().',
            );
        }

        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling deviceConnectorEdit().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/connectors`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: ConnectorDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Edit device connector details.
     */
    async deviceConnectorEdit(
        requestParameters: DeviceConnectorEditRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceConnectorEditRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get list of connector uptimes for a specified device. Will default to last 30 days if date range not specified.
     */
    async deviceConnectorUptimeRaw(
        requestParameters: DeviceConnectorUptimeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceConnectorUptimeResponse>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceConnectorUptime().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/connector-uptime`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceConnectorUptimeResponseFromJSON),
        );
    }

    /**
     * Get list of connector uptimes for a specified device. Will default to last 30 days if date range not specified.
     */
    async deviceConnectorUptime(
        requestParameters: DeviceConnectorUptimeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceConnectorUptimeResponse>> {
        const response = await this.deviceConnectorUptimeRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the daily uptimes for a specified device. Will default to last 30 days if date range not specified.
     */
    async deviceDailyUptimesRaw(
        requestParameters: DeviceDailyUptimesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceUptimeResponse>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceDailyUptimes().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/daily-uptimes`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceUptimeResponseFromJSON),
        );
    }

    /**
     * Get the daily uptimes for a specified device. Will default to last 30 days if date range not specified.
     */
    async deviceDailyUptimes(
        requestParameters: DeviceDailyUptimesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceUptimeResponse>> {
        const response = await this.deviceDailyUptimesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Decommission a device. Sets DecommissionedAt timestamp and DeviceAuthorizationMode to Reject. Requires system_device_provisioning permission.
     */
    async deviceDecommissionRaw(
        requestParameters: DeviceDecommissionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceDecommission().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/decommission`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Decommission a device. Sets DecommissionedAt timestamp and DeviceAuthorizationMode to Reject. Requires system_device_provisioning permission.
     */
    async deviceDecommission(
        requestParameters: DeviceDecommissionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceDecommissionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Device details
     */
    async deviceDetailRaw(
        requestParameters: DeviceDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceDetail().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceArchiveId"] != null) {
            queryParameters["deviceArchiveId"] =
                requestParameters["deviceArchiveId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceDtoFromJSON(jsonValue),
        );
    }

    /**
     * Device details
     */
    async deviceDetail(
        requestParameters: DeviceDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceDto> {
        const response = await this.deviceDetailRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Retrieve device extended configuration.
     */
    async deviceExtendedConfigurationGetRaw(
        requestParameters: DeviceExtendedConfigurationGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceConfigurationExtendedDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceExtendedConfigurationGet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/configuration-extended`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceConfigurationExtendedDtoFromJSON(jsonValue),
        );
    }

    /**
     * Retrieve device extended configuration.
     */
    async deviceExtendedConfigurationGet(
        requestParameters: DeviceExtendedConfigurationGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceConfigurationExtendedDto> {
        const response = await this.deviceExtendedConfigurationGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set (or add if not exist) device extended configuration item. Will return a taskId if device is online, else will update db. Admin only.
     */
    async deviceExtendedConfigurationUpdateRaw(
        requestParameters: DeviceExtendedConfigurationUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceExtendedConfigurationUpdate().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/configuration-extended`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PATCH",
                headers: headerParameters,
                query: queryParameters,
                body: ChangeExtendedConfigurationTaskToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set (or add if not exist) device extended configuration item. Will return a taskId if device is online, else will update db. Admin only.
     */
    async deviceExtendedConfigurationUpdate(
        requestParameters: DeviceExtendedConfigurationUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceExtendedConfigurationUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * List devices visible for the current IlluminateUser\'s accessTags. Supports paging
     */
    async deviceListRaw(
        requestParameters: DeviceListRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceListReponse>> {
        const queryParameters: any = {};

        if (requestParameters["registrationStatus"] != null) {
            queryParameters["registrationStatus"] =
                requestParameters["registrationStatus"];
        }

        if (requestParameters["deviceType"] != null) {
            queryParameters["deviceType"] = requestParameters["deviceType"];
        }

        if (requestParameters["deviceOwnerId"] != null) {
            queryParameters["deviceOwnerId"] =
                requestParameters["deviceOwnerId"];
        }

        if (requestParameters["accessTag"] != null) {
            queryParameters["accessTag"] = requestParameters["accessTag"];
        }

        if (requestParameters["nestChildDevices"] != null) {
            queryParameters["nestChildDevices"] =
                requestParameters["nestChildDevices"];
        }

        if (requestParameters["limit"] != null) {
            queryParameters["limit"] = requestParameters["limit"];
        }

        if (requestParameters["cursor"] != null) {
            queryParameters["cursor"] = requestParameters["cursor"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceListReponseFromJSON(jsonValue),
        );
    }

    /**
     * List devices visible for the current IlluminateUser\'s accessTags. Supports paging
     */
    async deviceList(
        requestParameters: DeviceListRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceListReponse> {
        const response = await this.deviceListRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * An OData endpoint that lists devices that are assignable to the provided device group. If the group is an org, returns only devices not in an org. If the group is a Site, returns only devices in the org and not in a Site. Else, if the group has an org, returns only devices in the org (even if caller is admin). Endpoint also ensures you have permission to assign devices to this group.
     */
    async deviceListForGroupAssignmentODataRaw(
        requestParameters: DeviceListForGroupAssignmentODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceDto>>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling deviceListForGroupAssignmentOData().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/device-groups/{deviceGroupTag}/devices-for-assignment-odata`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceDtoFromJSON),
        );
    }

    /**
     * An OData endpoint that lists devices that are assignable to the provided device group. If the group is an org, returns only devices not in an org. If the group is a Site, returns only devices in the org and not in a Site. Else, if the group has an org, returns only devices in the org (even if caller is admin). Endpoint also ensures you have permission to assign devices to this group.
     */
    async deviceListForGroupAssignmentOData(
        requestParameters: DeviceListForGroupAssignmentODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceDto>> {
        const response = await this.deviceListForGroupAssignmentODataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * An OData endpoint that lists devices visible for the current IlluminateUser. Pass an \'advancedSearch\' OData filter parameter to search across other fields (config item values (if device_config_read), Vendor, InternalNotes (if staff), DeviceAddress (if device_location_read)); eg $filter=contains(tolower(advancedSearch),\'offered\').
     */
    async deviceListODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceDtoFromJSON),
        );
    }

    /**
     * An OData endpoint that lists devices visible for the current IlluminateUser. Pass an \'advancedSearch\' OData filter parameter to search across other fields (config item values (if device_config_read), Vendor, InternalNotes (if staff), DeviceAddress (if device_location_read)); eg $filter=contains(tolower(advancedSearch),\'offered\').
     */
    async deviceListOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceDto>> {
        const response = await this.deviceListODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Begin live logging for a device. Admin only. Client must also call signalRHub.invoke(\'joinGroup\', `device_<deviceId>`), and listen to it via `signalRHub.on(\'deviceLiveLogUpdateMessage\', (message: DeviceLiveLogUpdateSrm) => {}` to receive messages.
     */
    async deviceLiveLogEnableRaw(
        requestParameters: DeviceLiveLogEnableRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceLiveLogEnable().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["expiryMinutes"] != null) {
            queryParameters["expiryMinutes"] =
                requestParameters["expiryMinutes"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/live-logging`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Begin live logging for a device. Admin only. Client must also call signalRHub.invoke(\'joinGroup\', `device_<deviceId>`), and listen to it via `signalRHub.on(\'deviceLiveLogUpdateMessage\', (message: DeviceLiveLogUpdateSrm) => {}` to receive messages.
     */
    async deviceLiveLogEnable(
        requestParameters: DeviceLiveLogEnableRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceLiveLogEnableRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update location. Includes lat/lng, address, friendlyName, timeZone.
     */
    async deviceLocationSetRaw(
        requestParameters: DeviceLocationSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceLocationSet().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/location`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update location. Includes lat/lng, address, friendlyName, timeZone.
     */
    async deviceLocationSet(
        requestParameters: DeviceLocationSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceLocationSetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get maintenance status logs for a device (IlluminateAdmin or JETChargeStaff users only)
     */
    async deviceMaintenanceStatusLogsOdataRaw(
        requestParameters: DeviceMaintenanceStatusLogsOdataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceMaintenanceStatusLogDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceMaintenanceStatusLogsOdata().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/maintenance-status-odata`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceMaintenanceStatusLogDtoFromJSON),
        );
    }

    /**
     * Get maintenance status logs for a device (IlluminateAdmin or JETChargeStaff users only)
     */
    async deviceMaintenanceStatusLogsOdata(
        requestParameters: DeviceMaintenanceStatusLogsOdataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceMaintenanceStatusLogDto>> {
        const response = await this.deviceMaintenanceStatusLogsOdataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set device managedBy in metadata. will update db. Admin only.
     */
    async deviceManagedByUpdateRaw(
        requestParameters: DeviceManagedByUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceManagedByUpdate().',
            );
        }

        if (requestParameters["managedBy"] == null) {
            throw new runtime.RequiredError(
                "managedBy",
                'Required parameter "managedBy" was null or undefined when calling deviceManagedByUpdate().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["managedBy"] != null) {
            queryParameters["managedBy"] = requestParameters["managedBy"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/set-managed-by`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PATCH",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set device managedBy in metadata. will update db. Admin only.
     */
    async deviceManagedByUpdate(
        requestParameters: DeviceManagedByUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceManagedByUpdateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get device\'s parent, or 404 if none
     */
    async deviceParentGetRaw(
        requestParameters: DeviceParentGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceParentGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceArchiveId"] != null) {
            queryParameters["deviceArchiveId"] =
                requestParameters["deviceArchiveId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/parent`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get device\'s parent, or 404 if none
     */
    async deviceParentGet(
        requestParameters: DeviceParentGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceDto> {
        const response = await this.deviceParentGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set or remove device\'s parent. Requires one of device_provisioning, partner_device_provisioning, system_device_provisioning permission.
     */
    async deviceParentSetRaw(
        requestParameters: DeviceParentSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceParentSet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceArchiveId"] != null) {
            queryParameters["deviceArchiveId"] =
                requestParameters["deviceArchiveId"];
        }

        if (requestParameters["parentDeviceIdentity"] != null) {
            queryParameters["parentDeviceIdentity"] =
                requestParameters["parentDeviceIdentity"];
        }

        if (requestParameters["parentDeviceArchiveId"] != null) {
            queryParameters["parentDeviceArchiveId"] =
                requestParameters["parentDeviceArchiveId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/parent`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set or remove device\'s parent. Requires one of device_provisioning, partner_device_provisioning, system_device_provisioning permission.
     */
    async deviceParentSet(
        requestParameters: DeviceParentSetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceParentSetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert (provision) a new device. If successful, device has been inserted to db and org assigned. Requires one of device_provisioning, partner_device_provisioning, system_device_provisioning permission. Can then use DeviceParentSet (same permissions), SetDeviceOwner (system_device_provisioning), DeviceAccessTagsSet (system_device_access_tags_update), DeviceGroupMapDevices (user: device_group_manage, partner: partner_device_provisioning, staff: system_device_provisioning), DeviceAuthorizationUpdate (device_passthrough_manage), DeviceConfigurationUpdate (device_config_update) APIs as needed to set access
     */
    async deviceProvisionRaw(
        requestParameters: DeviceProvisionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: ProvisionDeviceRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert (provision) a new device. If successful, device has been inserted to db and org assigned. Requires one of device_provisioning, partner_device_provisioning, system_device_provisioning permission. Can then use DeviceParentSet (same permissions), SetDeviceOwner (system_device_provisioning), DeviceAccessTagsSet (system_device_access_tags_update), DeviceGroupMapDevices (user: device_group_manage, partner: partner_device_provisioning, staff: system_device_provisioning), DeviceAuthorizationUpdate (device_passthrough_manage), DeviceConfigurationUpdate (device_config_update) APIs as needed to set access
     */
    async deviceProvision(
        requestParameters: DeviceProvisionRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceProvisionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Remove a device for e2e automation test purpose ONLY. Requires system_e2e_test_runner permission.
     */
    async deviceRemoveRaw(
        requestParameters: DeviceRemoveRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceRemove().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/remove/{deviceIdentity}`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Remove a device for e2e automation test purpose ONLY. Requires system_e2e_test_runner permission.
     */
    async deviceRemove(
        requestParameters: DeviceRemoveRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceRemoveRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Undo decommission of a device. Clears DecommissionedAt timestamp. Validates no other device with same serial number exists. Requires system_device_provisioning permission.
     */
    async deviceUndoDecommissionRaw(
        requestParameters: DeviceUndoDecommissionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceUndoDecommission().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/undo-decommission`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Undo decommission of a device. Clears DecommissionedAt timestamp. Validates no other device with same serial number exists. Requires system_device_provisioning permission.
     */
    async deviceUndoDecommission(
        requestParameters: DeviceUndoDecommissionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deviceUndoDecommissionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the uptimes for a specified device. Will default to last 30 days if date range not specified. New improved calculation method. Returns two uptime values: one that includes periods spent offline as \'up\' estimation and another that excludes offline periods from the \'up\' estimation.  Only applicable to devices with connectors.
     */
    async deviceUptimeRaw(
        requestParameters: DeviceUptimeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<DeviceUptimeResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling deviceUptime().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/uptime`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            DeviceUptimeResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get the uptimes for a specified device. Will default to last 30 days if date range not specified. New improved calculation method. Returns two uptime values: one that includes periods spent offline as \'up\' estimation and another that excludes offline periods from the \'up\' estimation.  Only applicable to devices with connectors.
     */
    async deviceUptime(
        requestParameters: DeviceUptimeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<DeviceUptimeResponse> {
        const response = await this.deviceUptimeRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set maintenance status for a device. Admin only.
     */
    async insertDeviceMaintenanceStatusRaw(
        requestParameters: InsertDeviceMaintenanceStatusOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling insertDeviceMaintenanceStatus().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/maintenance-status`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: InsertDeviceMaintenanceStatusRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set maintenance status for a device. Admin only.
     */
    async insertDeviceMaintenanceStatus(
        requestParameters: InsertDeviceMaintenanceStatusOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.insertDeviceMaintenanceStatusRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * An OData endpoint that lists PayMate Session Information.
     */
    async payMateSessionListODataRaw(
        requestParameters: PayMateSessionListODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<PayMateTransactionDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling payMateSessionListOData().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/paymate-sessions`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(PayMateTransactionDtoFromJSON),
        );
    }

    /**
     * An OData endpoint that lists PayMate Session Information.
     */
    async payMateSessionListOData(
        requestParameters: PayMateSessionListODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<PayMateTransactionDto>> {
        const response = await this.payMateSessionListODataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Temporarily enable auth for decommissioned device to allow reprovisioning. Sets configurable timeout with auto-rollback to Reject mode.
     */
    async prepareDeviceForReprovisioningRaw(
        requestParameters: PrepareDeviceForReprovisioningRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling prepareDeviceForReprovisioning().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["timeoutMinutes"] != null) {
            queryParameters["timeoutMinutes"] =
                requestParameters["timeoutMinutes"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/prepare-for-reprovisioning`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Temporarily enable auth for decommissioned device to allow reprovisioning. Sets configurable timeout with auto-rollback to Reject mode.
     */
    async prepareDeviceForReprovisioning(
        requestParameters: PrepareDeviceForReprovisioningRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.prepareDeviceForReprovisioningRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Complete device reprovisioning by creating new device and updating existing device\'s OCPP endpoint. Requires existing device to be online and in reprovisioning state.
     */
    async reprovisionDeviceRaw(
        requestParameters: ReprovisionDeviceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["existingDeviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "existingDeviceIdentity",
                'Required parameter "existingDeviceIdentity" was null or undefined when calling reprovisionDevice().',
            );
        }

        if (requestParameters["body"] == null) {
            throw new runtime.RequiredError(
                "body",
                'Required parameter "body" was null or undefined when calling reprovisionDevice().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{existingDeviceIdentity}/reprovision`.replace(
                    `{${"existingDeviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["existingDeviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: ReprovisionDeviceRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Complete device reprovisioning by creating new device and updating existing device\'s OCPP endpoint. Requires existing device to be online and in reprovisioning state.
     */
    async reprovisionDevice(
        requestParameters: ReprovisionDeviceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.reprovisionDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set operational at for a device. Requires device_operational_update permission.
     */
    async setDeviceOperationalStatusRaw(
        requestParameters: SetDeviceOperationalStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling setDeviceOperationalStatus().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["operationalAt"] != null) {
            queryParameters["operationalAt"] =
                requestParameters["operationalAt"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/operational-status`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set operational at for a device. Requires device_operational_update permission.
     */
    async setDeviceOperationalStatus(
        requestParameters: SetDeviceOperationalStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setDeviceOperationalStatusRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set active protocol for a device. Also disables passthroughs if not supported for the set protocol. Flags a device for Reboot.Possible error codes: 9002: Rebooting: Success. Device is now rebooting.
     */
    async setDeviceProtocolRaw(
        requestParameters: SetDeviceProtocolRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling setDeviceProtocol().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/protocol`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: DeviceProtocolUpdateDtoToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set active protocol for a device. Also disables passthroughs if not supported for the set protocol. Flags a device for Reboot.Possible error codes: 9002: Rebooting: Success. Device is now rebooting.
     */
    async setDeviceProtocol(
        requestParameters: SetDeviceProtocolRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setDeviceProtocolRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set/remove a real device as a readonly passthrough. Updates the real device\'s ReadonlyPassthroughConfig, Auth, ChargePointMetadata.ManagedBy, and soft resets the device. Use PassthroughConfigId=0 to remove a readonly passthrough. Requires Permission.device_passthrough_manage
     */
    async setReadonlyPassthroughDeviceRaw(
        requestParameters: SetReadonlyPassthroughDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling setReadonlyPassthroughDevice().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/set-readonly-passthrough`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: CreatePassthroughChildDeviceRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set/remove a real device as a readonly passthrough. Updates the real device\'s ReadonlyPassthroughConfig, Auth, ChargePointMetadata.ManagedBy, and soft resets the device. Use PassthroughConfigId=0 to remove a readonly passthrough. Requires Permission.device_passthrough_manage
     */
    async setReadonlyPassthroughDevice(
        requestParameters: SetReadonlyPassthroughDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setReadonlyPassthroughDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Start polling the specified Core device for Snapshot updates. Client must also call signalRHub.invoke(\'joinGroup\', `device_<deviceId>`), and listen to it via `signalRHub.on(\'coreSnapshotMessage\', (message: CoreSnapshotMessage) => {}` to receive messages.
     */
    async startPollingCoreSnapshotRaw(
        requestParameters: StartPollingCoreSnapshotRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling startPollingCoreSnapshot().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/start-polling-core-snapshot`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Start polling the specified Core device for Snapshot updates. Client must also call signalRHub.invoke(\'joinGroup\', `device_<deviceId>`), and listen to it via `signalRHub.on(\'coreSnapshotMessage\', (message: CoreSnapshotMessage) => {}` to receive messages.
     */
    async startPollingCoreSnapshot(
        requestParameters: StartPollingCoreSnapshotRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.startPollingCoreSnapshotRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update charger OCPP connection config
     */
    async updateChargerOcppConnectionRaw(
        requestParameters: UpdateChargerOcppConnectionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling updateChargerOcppConnection().',
            );
        }

        if (requestParameters["ocppConnectionUriTemplate"] == null) {
            throw new runtime.RequiredError(
                "ocppConnectionUriTemplate",
                'Required parameter "ocppConnectionUriTemplate" was null or undefined when calling updateChargerOcppConnection().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["ocppConnectionUriTemplate"] != null) {
            queryParameters["ocppConnectionUriTemplate"] =
                requestParameters["ocppConnectionUriTemplate"];
        }

        if (requestParameters["newDeviceIdentity"] != null) {
            queryParameters["newDeviceIdentity"] =
                requestParameters["newDeviceIdentity"];
        }

        if (requestParameters["reboot"] != null) {
            queryParameters["reboot"] = requestParameters["reboot"];
        }

        if (requestParameters["allowOnlyIfOnIlluminate"] != null) {
            queryParameters["allowOnlyIfOnIlluminate"] =
                requestParameters["allowOnlyIfOnIlluminate"];
        }

        if (requestParameters["refreshConfig"] != null) {
            queryParameters["refreshConfig"] =
                requestParameters["refreshConfig"];
        }

        if (requestParameters["validateOnly"] != null) {
            queryParameters["validateOnly"] = requestParameters["validateOnly"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/update-ocpp-connection`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update charger OCPP connection config
     */
    async updateChargerOcppConnection(
        requestParameters: UpdateChargerOcppConnectionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.updateChargerOcppConnectionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * An OData endpoint for querying device data, including uptime. Supports query options such as filtering, sorting, and paging for efficient data management.
     */
    async uptimeDeviceListODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime-devices-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceDtoFromJSON),
        );
    }

    /**
     * An OData endpoint for querying device data, including uptime. Supports query options such as filtering, sorting, and paging for efficient data management.
     */
    async uptimeDeviceListOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceDto>> {
        const response = await this.uptimeDeviceListODataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Validate if user can create new devices (has permission, Vendor has not exceeded provisioning limit, etc). Optionally provide a new device identity to check if that is valid and available (this checks across all orgs in system).
     */
    async validateNewDeviceRaw(
        requestParameters: ValidateNewDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        if (requestParameters["newDeviceIdentity"] != null) {
            queryParameters["newDeviceIdentity"] =
                requestParameters["newDeviceIdentity"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/validate-new-device`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Validate if user can create new devices (has permission, Vendor has not exceeded provisioning limit, etc). Optionally provide a new device identity to check if that is valid and available (this checks across all orgs in system).
     */
    async validateNewDevice(
        requestParameters: ValidateNewDeviceRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.validateNewDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}

/**
 * @export
 */
export const DeviceListRegistrationStatusEnum = {
    Unverified: "unverified",
    Inactive: "inactive",
    Active: "active",
} as const;
export type DeviceListRegistrationStatusEnum =
    (typeof DeviceListRegistrationStatusEnum)[keyof typeof DeviceListRegistrationStatusEnum];
/**
 * @export
 */
export const DeviceListDeviceTypeEnum = {
    ChargePoint: "chargePoint",
    Illuminate: "illuminate",
    ThirdPartyPassthrough: "thirdPartyPassthrough",
    PayMate: "payMate",
    Wave: "wave",
    PowerMeter: "powerMeter",
    Core: "core",
    Barrier: "barrier",
} as const;
export type DeviceListDeviceTypeEnum =
    (typeof DeviceListDeviceTypeEnum)[keyof typeof DeviceListDeviceTypeEnum];
/**
 * @export
 */
export const DeviceManagedByUpdateManagedByEnum = {
    ChargefoxDev: "chargefoxDev",
    ChargefoxStaging: "chargefoxStaging",
    ChargefoxProd: "chargefoxProd",
    Illuminate: "illuminate",
    Exploren: "exploren",
    Fortum: "fortum",
    ChargeHq: "chargeHq",
    DynamicPassthroughParent: "dynamicPassthroughParent",
    DynamicPassthroughChild: "dynamicPassthroughChild",
    GatewayDynamicPassthroughChild: "gatewayDynamicPassthroughChild",
    ServerlessFunctionApp: "serverlessFunctionApp",
} as const;
export type DeviceManagedByUpdateManagedByEnum =
    (typeof DeviceManagedByUpdateManagedByEnum)[keyof typeof DeviceManagedByUpdateManagedByEnum];
